import { styled } from '@mui/material';
import { LANGUAGE_OPTIONS } from 'locales/constants';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Button, Form, Stack, Text, TextInput, Tooltip } from 'shell/components';

const DesktopCourseDetails = ({ loading, form, isDirty, errors, onChange, onSubmit, handleSettingDropDown }) => {
    const { t } = useTranslation();
    return (
        <CustomStack spacing={4}>
            <Stack alignItems={'center'} direction={'row'} spacing={4}>
                <Text component={'p'} variant={'h6'} weight={'semibold'}>
                    {t('course-settings.course-details.title', 'Course Details')}
                </Text>
                {/* <Dropdown
                    id={'course-setting-dropdown'}
                    options={[{ key: 'delete', value: 'Delete Course' }]}
                    rootComponent={
                        <IconButton
                            aria-label={'more options'}
                            kind={'moreHorizontal'}
                            size={'medium'}
                            variant={'square'}
                        />
                    }
                    onSelect={handleSettingDropDown}
                /> */}
            </Stack>
            <CustomForm onSubmit={onSubmit}>
                <TextInput
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                    label={t('course-settings.course-details.course-name-label', 'Course Name')}
                    required
                    value={form.name}
                    onChange={(e) => onChange('name', e.target.value)}
                />
                <Autocomplete
                    disableClearable
                    label={
                        <Stack alignItems={'center'} direction={'row'} spacing={2}>
                            <Text>
                                {t('course-settings.course-details.feedback-language-label', 'Feedback Language')}
                            </Text>
                            <Tooltip
                                content={t(
                                    'course-settings.course-details.feedback-language-tooltip',
                                    'Choose the language you want assignment feedback to be delivered in. If you change this setting midway through a course, any new feedback generated from that point on will use the updated language.'
                                )}
                                type={'info'}
                            />
                        </Stack>
                    }
                    options={LANGUAGE_OPTIONS}
                    placeholder={t('ui.select', 'Select')}
                    value={form?.language}
                    onChange={(_, value) => onChange('language', value)}
                />
                <ButtonStack>
                    <Button disabled={!isDirty} loading={loading} type={'submit'}>
                        {t('controls.save', 'Save')}
                    </Button>
                </ButtonStack>
            </CustomForm>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5),
        maxWidth: '50rem',
        height: 'calc(100vh - 64px - 20px)',
    };
});

const CustomForm = styled(Form)(({ theme }) => {
    return {
        display: 'grid',
        gridTemplateColumns: '359px',
        gridGap: theme.spacing(4),
    };
});

const ButtonStack = styled(Stack)(() => {
    return {
        gridColumn: '1',
        marginLeft: 'auto',
    };
});

export default DesktopCourseDetails;
